import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "@/shared/auth/useAuth";
import { Spinner } from "@/shared/ui/Spinner";

/** Pages for signed-in admins only: others go to sign-in, and come back here after. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();
  if (status === "checking") return <Spinner label={t("checkingSession")} />;
  if (status === "signed-out") {
    return <Navigate to={`/sign-in?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }
  return <>{children}</>;
}
